export default {
  ai: {
    k_001001: 'api 未定义',
    k_001002: '00:00-07:00期间系统升级中，由此给您带来不便，敬请谅解！',
    k_002001: 'token参数缺失',
    k_002002: '接口请求出现异常',
    k_002003: '请求信息失败',
    k_002004: '解析用户信息错误',
    k_002005: '获取信息失败',
    k_003001: 'AI基础',
    k_003002: '智能解析',
    k_003003: '智能字幕',
    k_003004: 'AI运营',
    k_003005: '精彩时刻',
    k_003006: '精彩剪辑',
    k_003007: '概要总结',
    k_003008: '精准识别视频中的人声并形成字幕，讲解内容与时间匹配自动生成字幕',
    k_003009: '智能挑选视频中的关键亮点，让关注更便捷观看自己感兴趣的内容',
    k_003010: '智能识别视频内容，剪辑成多个精彩片段，让内容沉淀再传播',
    k_003011: '智能提取关键信息，自动总结，让核心内容一目了然',
    k_004001: '上传图片只能是 {0} 格式',
    k_004002: '上传图片大小不能超过 {0}',
    k_005001: '获取回放信息失败',
    k_005002: '请视频转码成功后再使用此功能',
    k_005003: '查询语音识别信息失败',
    k_005004: '获取回放详情信息失败',
    k_005005: '正在进行智能解析，请稍后再试',
    k_005006: '请切换至「智能解析」进行分析总结后，再使用此功能',
    k_007001: '倍速',
    k_008001: '图片处理',
    k_008002: '全屏拉伸',
    k_008003: '等比缩放自适应',
    k_008004: '等比缩放显示全图',
    k_008005: '裁剪',
    k_008006: '取消裁剪',
    k_008007: '重新上传',
    k_008008: '取消',
    k_008009: '确定',
    k_009001: '音视频列表',
    k_009002: '退出登录',
    k_009003: '退出失败',
    k_010001: '活动平台DEP',
    k_011001: '去设置',
    k_012001: '请输入标题',
    k_012002: '标题不能为空',
    k_012003: '长度在 1 到 200 个字符',
    k_012004: '编辑',
    k_013001: '暂无数据',
    k_013002: '暂未搜索到您想要的内容',
    k_014001: '请输入关键词',
    k_015001: '上传失败',
    k_015002: '您输入的内容超出{0}限制',
    k_015003: '您输入的内容超出{0}限制，已自动取消',
    k_016001: '封面',
    k_016002: '更换',
    k_016003: '删除',
    k_016004: '上传失败',
    k_016005: '图片上传中...',
    k_017001: '倍速',
    k_018001: '预览',
    k_019001: '正在创作：',
    k_019002: '全文内容',
    k_019003: '文档',
    k_020001: '查看功能介绍',
    k_020002: '联系客服',
    k_020003: '「AI创作」是收费功能。请联系您的客户经理或专属售后。也可拨打400-888-9970转2咨询',
    k_020004:
      '尊敬的用户，您的账号已到期。为了保证正常使用，请联系您的客户经理或专属售后，也可拨打400-888-9970转2咨询',
    k_021001: '页面已失联，攻城狮正在赶来的路上…',
    k_021002: '无法访问本页的原因：',
    k_021003: '服务器过热导致网站可能出现故障！',
    k_021004: '所访问的页面不存在或者已被管理员删除！',
    k_021005: '返回',
    k_021006: '返回首页',
    k_022001: '账号绑定',
    k_022002: '用户登录',
    k_022003: '账号登录',
    k_022004: '手机登录',
    k_022005: '用户名/邮箱/手机号',
    k_022006: '请输入密码',
    k_022007: '登   录',
    k_022008: '请输入手机号',
    k_022009: '该手机号未注册，请先注册',
    k_022010: '动态密码',
    k_022011: '获取验证码',
    k_022012: '登 录',
    k_022013: '请输入正确的手机号',
    k_022014: '请输入账号',
    k_022015: '包含大小写字母,数字在内的6-30个字符',
    k_022016: '请输入短信验证码',
    k_022017: '请先阅读并同意隐私政策及用户服务协议',
    k_022018: '账号不存在',
    k_022019: '登录验证失败',
    k_022020: '登录失败！',
    k_022021: '该手机号已注册',
    k_022022: '注册失败',
    k_022023: '图形验证码错误',
    k_023001: '其他登录方式:',
    k_023002: '请求失败',
    k_024001: '阅读并同意',
    k_024002: '提交即同意',
    k_024003: '《隐私政策》',
    k_024004: '及',
    k_024005: '《用户服务协议》',
    k_025001: '音视频',
    k_025002: '音视频中的文件内容应用于暖场视频、点播、定时直播和插播文件',
    k_025003: '1.上传单个文件最大5G',
    k_025004: '2.上传视频格式支持RMVB、MP4、AVI、WMV、MKV、FLV、MOV；上传音频格式支持MP3',
    k_025005: '3.上传的视频，不支持剪辑和下载',
    k_025006: '上传',
    k_025007: '批量删除',
    k_025008: '请输入音视频名称',
    k_025009: '音视频名称',
    k_025010: '上传时间',
    k_025011: '时长',
    k_025012: '转码后大小',
    k_025013: '进度',
    k_025014: '上传已完成',
    k_025015: '文件上传中',
    k_025016: '操作',
    k_025017: '预览',
    k_025018: 'AI创作',
    k_025019: '编辑',
    k_025020: '删除',
    k_025021: '请求失败',
    k_025022: '转码中',
    k_025023: '转码成功',
    k_025024: '转码失败',
    k_025025: '您上传的文件格式不正确',
    k_025026: '您上传的文件不能大于5G',
    k_025027: '上传过程中请勿关闭或刷新浏览器',
    k_025028: '文件正在上传中',
    k_025029: '本地上传失败',
    k_025030: '上传视频成功',
    k_025031: '创建音视频失败',
    k_025032: '请视频转码成功后再使用此功能',
    k_025033: '名称不能为空',
    k_025034: '修改失败',
    k_025035: '修改成功',
    k_025036: '该文件已被关联，删除将导致相关文件无法播放且不可恢复，确认删除？',
    k_025037: '提示',
    k_025038: '确定',
    k_025039: '取消',
    k_025040: '删除后将会影响暖场视频的演示和观看，确认删除？',
    k_025041: '删除失败',
    k_025042: '删除成功',
    k_026001: '选中文字后，点击鼠标左键 进行添加',
    k_026002: '我知道了',
    k_026003: '添加',
    k_026004: '请求失败',
    k_027001: '获取精彩片段信息失败',
    k_027002: '精彩剪辑可创作的片段数量最小3个，最多30个',
    k_027003: '任务请求提交失败',
    k_028001: '精彩片段还不够？试试手动添加！',
    k_028002: '+ 我要添加',
    k_028003: '重新创作',
    k_028004: '重新创作会覆盖上一次的创作内容，',
    k_028005: '以及手动添加的内容',
    k_028006: '加载中...',
    k_028007: '生成失败',
    k_028008: '添加至音视频',
    k_028009: '下载',
    k_028010: '收起',
    k_028011: '展开',
    k_028012: '重新创作将会覆盖上一次创作的内容，确定重新创作？',
    k_028013: '提示',
    k_028014: '确定',
    k_028015: '取消',
    k_028016: '请求失败',
    k_028017: '添加成功',
    k_029001: '精彩片段数量',
    k_029002: '关键信息',
    k_029003:
      '非必填项，请输入关键信息，用以对AI生成结果进行个性化定制，如：结果需要包含微吼DEP平台的介绍，需要有EventHub、WebcastingHub、DataHub关键字',
    k_029004: '字数要求',
    k_029005: '非必填项，≤30',
    k_029006: '参考示例',
    k_029007: '非必填项，可输入需要参考的示例内容，便于AI按照此示例的格式进行输出',
    k_029008: '开始创作',
    k_030001: '下载',
    k_030002: '时长：',
    k_030003: '内容：',
    k_030004: '开始转码',
    k_030005: '提示：',
    k_030006: '1.视频时间越长且视频带有字幕，转码时间越长，请耐心等待',
    k_030007: '2.转码成功后，可下载视频至本地电脑；如果您已设置字幕，则包含有字幕和无字幕2个',
    k_030008: '重新转码',
    k_030009: '立即下载',
    k_030010: '视频转码中，请耐心等待，关闭弹窗，转码不中断',
    k_030011: '转码失败，请重试',
    k_030012: '获取视频片段信息失败',
    k_030013: '提交请求失败',
    k_031001: '我要添加',
    k_031002: '全文总结',
    k_031003: '最多添加50个内容',
    k_031004: '取消',
    k_031005: '确定',
    k_031006: '至少添加1个内容',
    k_031007: '请求失败',
    k_032001: '请切换至「智能解析」进行分析总结后，再使用「{0}」功能',
    k_032003: '创作时间根据视频时长而定，请耐心等待',
    k_032004: '创作失败，请重新进行创作',
    k_032005: '开始创作',
    k_032006: '智能解析',
    k_032007: '内容识别',
    k_032008: '内容校正',
    k_032009: '校正完成',
    k_032010: '精彩时刻',
    k_032011: '基础设置',
    k_032012: '精彩时刻列表',
    k_032013: '精彩剪辑',
    k_032014: '精彩片段列表',
    k_032015: '概要总结',
    k_032016: '概要总结内容',
    k_032017: '智能字幕',
    k_032018: 'mock 子组件slot出参',
    k_033001: '智能解析',
    k_033002:
      '对活动视频进行解析，通过AI能力获得基础文本信息，实现对高阶能力的支持，如设置精彩时刻、精彩剪辑、概要总结、智能字幕',
    k_033003: '精彩时刻',
    k_033004: '通过AI能力，智能挑选视频中的关键亮点，让观众更便捷观看自己感兴趣的内容 ',
    k_033005: '精彩剪辑',
    k_033006: '智能识别视频内容，剪辑成多个精彩片段，让内容沉淀再传播',
    k_033007: '概要总结',
    k_033008: '智能提取关键信息，自动总结，让核心内容一目了然 ',
    k_033009: '智能字幕',
    k_033010: '精准识别视频中的人声并形成字幕，讲解内容与时间匹配自动生成字幕',
    k_034001: '选中文字后，点击鼠标左键 进行添加',
    k_034002: '我知道了',
    k_034003: '添加',
    k_034004: '打点任务执行中，请稍后再试...',
    k_035001: '加载中...',
    k_035002: '更换图片',
    k_035003: '144x81，2m以内，jpg/png',
    k_035004: '收起',
    k_035005: '展开',
    k_035006: '共{0}个字',
    k_035008: '删除',
    k_035009: '上传失败',
    k_035010: '请输入文字',
    k_036001: '精彩时刻还不够？试试手动添加！',
    k_036002: '+ 我要添加',
    k_036003: '重新创作',
    k_036004: '重新创作会覆盖上一次的创作内容，',
    k_036005: '以及手动添加的内容',
    k_036006: '暂无内容',
    k_036007:
      '保存后在观看端默认显示“精彩时刻”，可在“自定义菜单”中调整展示位置、名称及控制是否显示',
    k_036008: '查看效果',
    k_036009: '保存',
    k_036010: '任务请求提交失败',
    k_036011: '重新创作将会覆盖上一次创作的内容，确定重新创作？',
    k_036012: '提示',
    k_036013: '确定',
    k_036014: '取消',
    k_036015: '删除成功',
    k_036016: '请添加精彩时刻后保存',
    k_036017: '修改成功',
    k_037001: '精彩时刻数量',
    k_037002: '关键信息',
    k_037003:
      '非必填项，请输入关键信息，用以对AI生成结果进行个性化定制，如：结果需要包含微吼DEP平台的介绍，需要有EventHub、WebcastingHub、DataHub关键字',
    k_037004: '字数要求',
    k_037005: '非必填项，≤30',
    k_037006: '参考示例',
    k_037007: '非必填项，可输入需要参考的示例内容，便于AI按照此示例的格式进行输出',
    k_037008: '开始创作',
    k_037009: '精彩时刻数量不能为空',
    k_038001: '撤销',
    k_038002: '还原',
    k_038003: '搜索',
    k_038004: '若内容识别不准确，鼠标左键点击文字进行编辑修改',
    k_038005: '内容由AI模型生成，微吼不对内容准确性和完整性做任何保证，亦不代表我们的观点或态度',
    k_038006: '完成内容校正后，再设置精彩时刻、精彩剪辑、概要总结、智能字幕时，展示效果更准确！',
    k_038007: '保存',
    k_038008: '请求失败',
    k_039001: 'AI运营',
    k_039002: '全文内容',
    k_039003: '内容已校正完成，您可以设置以下功能：',
    k_039004: '下载txt文档',
    k_039005: '去设置',
    k_039006: '上一步',
    k_039007: '{0}-视频文本内容-{1}.txt',
    k_039008: '请求信息失败',
    k_040001: '输出语言',
    k_040002: '请选择',
    k_040004: '开始解析',
    k_040005: '提示：',
    k_040006: '1.如果视频是中文，输出语言请选择「简体中文」；英文请选择「English」；不支持语言翻译',
    k_040007: '2.反复进行解析时，会覆盖上一次的解析结果及校正记录',
    k_040008: '重新解析将会覆盖上一次的解析结果及校正记录，确定重新解析？',
    k_040009: '提示',
    k_040010: '确定',
    k_040011: '取消',
    k_040012: '参数错误',
    k_040013: '该视频暂时不支持进行智能解析',
    k_040014: '解析任务请求提交失败',
    k_041001: '暂无解析',
    k_041002: '当前视频时长低于3分钟，请选择其他视频进行解析',
    k_041003: '解析时间根据视频时长而定，请耐心等待',
    k_041004: '解析失败，请重新解析',
    k_041005: '内容识别',
    k_041006: '内容校正',
    k_041007: '校正完成',
    k_042001: '内容校正',
    k_042002: '请输入内容',
    k_042003: '共{0}字',
    k_042005: '取消',
    k_042006: '确定',
    k_043001: '请切换至「智能解析」进行分析总结后，再使用「智能字幕」功能',
    k_043002: '智能字幕',
    k_043003: '已开启，观众端观看视频显示字幕信息',
    k_043004: '开启后，观众端观看视频显示字幕信息',
    k_043005: '下载txt文档',
    k_043006: '编辑字幕',
    k_043007: '重新生成',
    k_043008: '重新生成会覆盖上一次的字幕内容',
    k_043009: '保存后，观看视频时可看到字幕效果，以及在「精彩剪辑」中可下载带字幕视频',
    k_043010: '取消',
    k_043011: '保存',
    k_043012: '「生成字幕」后才能进行设置字幕以及在「精彩剪辑」中下载带有字幕的视频',
    k_043013: '生成字幕',
    k_043014: '生成失败，请重新',
    k_043015: '开始创作',
    k_043016: '获取智能字幕相关信息失败',
    k_043017: '参数错误',
    k_043018: '智能字幕生成失败',
    k_043019: '操作失败',
    k_043020: '{0} 智能字幕',
    k_043021: '开启',
    k_043022: '关闭',
    k_043023: '{0}-字幕文件-{1}.txt',
    k_043024: '重新生成字幕将会覆盖上一次修改的字幕内容，确定重新生成？',
    k_043025: '提示',
    k_043026: '确定',
    k_043027: '智能字幕保存失败',
    k_043028: '保存成功',
    k_044001: '设置字幕样式',
    k_044002: '文字大小',
    k_044003: '请选择',
    k_044004: '文字样式',
    k_044005: '文字颜色',
    k_044006: '不透明度',
    k_044007: '描边颜色',
    k_044008: '取消',
    k_044009: '确定',
    k_044010: '获取字幕样式配置信息失败',
    k_044011: '参数错误',
    k_044012: '设置失败',
    k_044013: '设置成功',
    k_045001: '主题',
    k_045002: '重新创作',
    k_045003: '重新创作会覆盖上一次的创作内容，以及手动添加的内容',
    k_045004: '关键词',
    k_045005: '新增',
    k_045006: '概要总结',
    k_045007:
      '保存后在观看端默认显示“概要总结”，可在“自定义菜单”中调整展示位置、名称及控制是否显示',
    k_045008: '查看效果',
    k_045009: '保存',
    k_045010: '请输入关键词',
    k_045011: '添加关键词',
    k_045012: '取消',
    k_045013: '确定',
    k_045014: '主题名称',
    k_045015: '任务请求提交失败',
    k_045016: '重新创作将会覆盖上一次创作的内容，确定重新创作？',
    k_045017: '提示',
    k_045018: '删除成功',
    k_045019: '至少保留一个关键词',
    k_045020: '请输入主题',
    k_045021: '请输入概要总结',
    k_045022: '修改成功',
    k_046001: '关键词数量',
    k_046002: '关键信息',
    k_046003:
      '非必填项，请输入关键信息，用以对AI生成结果进行个性化定制，如：结果需要包含微吼DEP平台的介绍，需要有EventHub、WebcastingHub、DataHub关键字',
    k_046004: '字数要求',
    k_046005: '非必填项，≤300',
    k_046006: '参考示例',
    k_046007: '非必填项，可输入需要参考的示例内容，便于AI按照此示例的格式进行输出',
    k_046008: '开始创作',
    k_046009: '精彩时刻数量不能为空'
  },
  errorMap: {
    200: '操作成功',
    201: '参数错误',
    330: '请求失败',
    400: '请求参数错误',
    404: '资源不存在',
    500: '系统忙，请稍后再试',
    501: '系统忙，请稍后再试',
    502: '系统忙，请稍后再试',
    600: '请求参数错误',
    601: '已存在该记录',
    602: '未找到对应用户信息',
    603: '有关联的资源API,不能删除',
    700: '操作异常！',
    701: '查询失败！',
    710: '操作异常！',
    711: '操作异常！',
    712: '查询失败！',
    720: '签名验证失败！',
    1005: 'timestamp 过期',
    1008: '签名校验失败',
    1009: 'app_id无效',
    10000: '登录验证失败',
    10017: 'sort 参数 错误',
    13220: '点赞数据更新失败',
    20002: '分组名称不能重名',
    20004: '智能分组规则不能为空',
    20005: '分组不存在或已删除',
    20011: '删除分组失败',
    20013: '创建智能分组失败',
    20015: '参数consumer_uid必须为大于零的整数',
    20016: '手机号或邮箱不匹配',
    20040: 'A下C存在该用户，但是B下C不存在',
    20045: '用户标签分类不正确',
    20046: '分组名称长度超过限制',
    20047: '分组描述长度超过限制',
    20052: '获取系统分组成员失败',
    20070: '智能分组规则格式不正确',
    20101: '添加成员失败',
    20103: '分组不属于该用户',
    20500: '【B端用户企业信息更新】执行异常!',
    20501: '第三方用户不存在!',
    20502: '手机号或邮箱已和其它账号绑定过!',
    20503: '手机号和邮箱不是同一个账号!',
    20506: '账号已存在，请勿重复创建!',
    21000: '分类不存在',
    21001: '标签名已存在',
    21002: '分类名不可为空',
    21003: '分类名已存在',
    21004: '标签名不能为空',
    21005: '添加失败',
    21006: '更新失败',
    21007: 'B端用户没有该标签',
    30001: '数据格式错误',
    30002: '批量添加到分组失败',
    30003: '商户转账场景不匹配',
    30006: '用户不存在',
    30012: '当前余额 小于 扣减余额',
    30014: '用户id已存在，不能重复创建',
    30015: '用户id和ssoid不能同时为空',
    30016: '第三方用户查询user_id、union_id、id、account_id不能同时为空',
    30017: 'C端用户不存在',
    30018: 'b端用户不存在',
    30019: 'union_id、account和business_account_id、user_id不能同时为空',
    30020: 'user_id、union_id、phone、nick_name、email、wx_open_id、name不能同时为空',
    30021: '该用户非老用户，不能升为b端用户',
    30022: '该用户非老用户，不能降为c端用户',
    30023: 'account_id和user_id不能同时为空',
    30024: 'user_ids不能为空',
    30025: '未开启私域用户池功能',
    30026: '用户配置类型不存在',
    50001: '微信联合id没有绑定手机号',
    50005: '手机号和微信联合id都为空',
    50012: 'phone不能为空',
    50013: '报名手机格式不正确',
    50014: '预约手机格式不正确',
    50050: 'consumer_uids和visitor_ids不能同时为空',
    50100: '手机格式不正确',
    50101: '邮箱格式不正确',
    50210: 'wx_union_id、wx_open_id、wx_qr_open_id 不能同时为空',
    50211: '邮箱、手机号、用户名不能同时为空',
    50212: '账号不能为空',
    50213: '密码不能为空',
    50214: 'SSO统一id不能为空',
    50400: '数据更新失败',
    60000: 'audience_id不能同时为空',
    60001: '故障码配置信息不存在',
    60002: '故障码配置信息已存在',
    60003: '故障码已停用',
    60004: '故障码发布信息已存在',
    100001: '活动ID格式不正确',
    200021: 'C端用户ID格式不正确',
    200023: '首次进入活动时间格式不正确',
    200025: '参数中时间格式不正确，应为yyyy-MM-dd HH:mm:ss',
    200026: '是否新用户格式不正确',
    200035: '渠道来源格式不正确',
    200040: '参会的游客id不存在',
    200041: '报名手机格式不正确',
    200042: '预约手机格式不正确',
    200043: '第三方用户ID不正确',
    200044: '角色的ID不正确',
    200045: 'first_join_at、sign_up_time、appointment_time 、is_new、source不能同时不传',
    410000: '活动与用户不匹配',
    410001: '场次与活动不匹配',
    410002: '未获取到登录用户信息',
    410003: '查询活动数量超限，请重新选择查询条件',
    410004: '未获取到有效的登录用户ID',
    410005: '站点与用户不匹配',
    410006: '文件上传失败',
    410007: '文件下载失败',
    500000: '失败',
    510000: '参数错误',
    510001: '未知错误',
    510002: '结果数据错误',
    510003: '未定义返回字段类型',
    510004: '未定义返回字段是否必须',
    510005: '返回结果必须是对象',
    510006: '验证规则不可为空',
    510007: '没有权限',
    510008: '未登录',
    510009: '用户不存在',
    510010: '操作失败，请稍后重试',
    510011: '平台参数错误',
    510012: '找不到app应用',
    510013: '不能包含中文和特殊字符！',
    510014: '开始时间不能小于结束时间！',
    510015: '00:00-07:00期间系统升级中，由此给您带来不便，敬请谅解！',
    510016: '数据条数超出限制',
    510017: '缺失公共参数：B用户id',
    510018: '验证码错误',
    510019: '请先登陆',
    510020: '开启失败，该活动已开启预约前强制登录，请关闭后重试',
    510021: '配置项格式错误',
    510025: '此数据已存在，请重新设置',
    510037: '无法访问',
    510040: '数据不存在',
    510041: '数据不属于当前用户',
    511001: '图形验证码错误',
    511002: '动态密码错误',
    511003: '账号密码错误！如连续输错4次，您的账号将被锁定',
    511004: '您的账号由于不合规操作，已被封停！',
    511005: 'token缺失',
    511006: '用户token认证失败',
    511007: '用户token已过期',
    511008: '数据不存在',
    511009: '验证码错误',
    511010: '用户注册中心注册失败',
    511011: '用户已存在',
    511012: '上一步操作结果，验证失败',
    511013: '旧密码不能为空',
    511014: '旧密码错误',
    511015: '密码输入不一致',
    511016: '手机号格式错误',
    511017: '邮箱格式错误',
    511018: '验证码错误',
    511019: '发送验证码失败',
    511020: '子账号没有权限操作',
    511021: '不是子账号',
    511022: '该手机号已被其他账号绑定，请使用其他手机号',
    511023: '该邮箱已被其他账号绑定，请使用其他邮箱',
    511024: '请勿短时间内重复请求',
    511025: '上传头像异常',
    511026: '当前第三方用户已创建,密码数据不一致,请使用更新接口修改数据',
    511027: '当前用户已在saas平台上删除, 请先恢复',
    511028: '第三方用户对象不存在',
    511029: '超过子账号个数限制',
    511030: '角色id不正确，非主账号创建的',
    511031: '子账号没有操作权限',
    511032: '密码已存在，不允许直接设置',
    511033: '没有权限访问',
    511034: '无效的平台',
    511035: '只能修改自己账号下的数据',
    511036: '用户存在',
    511037: '上传图片过大',
    511038: '上传文件类型不支持',
    511039: '当前账号已绑定，请先解绑',
    511040: '批量创建子账号,数量不能为空',
    511041: '第三方账号信息缺失，请重新扫描',
    511042: '已被其他账号绑定',
    511043: '接口访问次数达到最大值限制',
    511044: '数据签名错误',
    511045: '数据异常，当前登录用户不存在',
    511046: 'sign_type值不正确!',
    511047: '权限key不存在',
    511048: '子账号关系错误',
    511049: '修改菜单排序失败',
    511050: '邮箱不符合要求，必须是公司邮箱！',
    511051: '封号原因不能为空',
    511052: '当前用户没有该增值api，请联系客服',
    511053: '当前账号未绑定，无须解绑',
    511054: '账号所属关系错误',
    511055: '手机号未注册',
    511056: '你不是员工',
    511057: '请输入正确的验证码',
    511058: '无效的token，平台参数错误',
    511059: '不允许对非会员或者已过期会员添加该配置项',
    511060: '无效事件',
    511061: '子账号数量为1~200个！',
    511062: '该账号为子账号，不能开通子账号权限！',
    511063: '子账号直播中，不允许删除',
    511064: '子账号有收益，不允许删除',
    511065: '请求已过期，请重新发起!',
    511066: '数据签名错误!',
    511067: '应用不存在',
    511068: '没有子账号权限',
    511069: '权限key已存在',
    511070: '未开通openapi权限',
    511071: '未开通jssdk权限',
    511072: '未开通appsdk权限',
    511073: '未开通小程序sdk权限',
    511074: '无效的会员',
    511075: '请填写本人手机号',
    511076: '迁移中用户暂不可访问',
    511077: '此游客已存在无需创建',
    511078: '邮箱不能为空',
    511079: '当前账号禁止登录，请联系客服人员',
    511080: '发布失败',
    511081: '请先停用全局故障码',
    511082: '时长计费不允许创建子账户',
    511083: '老系统不支持时长套餐，如需回退请更改套餐后再操作',
    511084: '你的应用已过期，请联系客服人员',
    511085: 'app_id未生效或已关闭',
    511086: '应用已停用',
    511087: '用户未注册',
    511088: '签名缺少signed_at参数',
    511089: 'signed_at已过期',
    511090: '该账户已注册，请前往登录',
    511091: '此用户手机号不为空！！！',
    511092: '子账号不可退回三方账号！',
    511093: '非纯化蝶用户不允许开通：聚合站点、系列会、单场活动及datahub任一权限',
    511094: '账号密码输入错误4次，账号锁定10分钟',
    511095: '未开通私域用户池权限',
    511096: '手机号或者邮箱已存在！',
    511097: '手机号和邮箱不是同一用户！',
    511098: '回放有效期类型为全天时，start_date和end_date不能为空',
    511099: '回放有效期类型为部分时段时，start_time和end_time不能为空',
    511100: '密码必须包含大小写字母和数字，长度为6-30位',
    511101: '此子账号已欠费，请充值后重试！',
    511102: '设置logo和使用父账号logo权限不能同时打开',
    511103: '举报反馈不允许关闭！',
    511501: '数据不存在！',
    511502: '数据已存在',
    511503: '数据库错误',
    511504: '权限分类id不能为空',
    511505: '账号被禁言',
    511506: 'Sso注册失败',
    511507: '注册失败',
    511508: '权限使用中，不允许删除子账号权限',
    511509: '超过app应用最大限制',
    511510: '没有开发者权限',
    511511: '权限id异常',
    511512: '用户不存在',
    511513: '与已有员工邮箱重复，请重新输入！',
    511514: '与已有员工姓名重复，请重新输入！',
    511515: '有关联用户，不能删除',
    511516: '只能修改自己的数据',
    511517: '手机号不存在',
    511518: '缺少转移员工ID',
    511521: '当前api_url不正确',
    511522: '当前用户没有该增值api，请联系客服',
    511523: '已存在该限频配置',
    511524: 'Id不存在',
    511525: '用户api权限没有开通',
    511528: '该用户已配置该接口！',
    511529: '修改菜单排序失败',
    511530: 'user_id不能为空',
    511531: '无账户下修改权限',
    511532: '进行中状态不允许修改！',
    511533: '不是进行中状态不允许取消！',
    511534: '距离迁移24小时内不允许取消',
    511535: '该用户无需迁移！',
    511536: '请检测id',
    512000: '删除失败,数据存在异常',
    512001: '删除失败',
    512002: '活动不存在或已删除',
    512003: '该活动不属于此用户',
    512004: '活动创建失败',
    512005: '活动扩展信息创建失败',
    512006: '活动修改失败',
    512007: '活动修改异常',
    512008: '暖场视频删除异常',
    512009: '暖场视频封面更换失败',
    512010: '暖场视频不存在',
    512011: '暖场视频添加失败',
    512012: '观众分组创建失败',
    512013: '观众分组修改失败',
    512014: '观众分组删除失败',
    512015: '分组不存在',
    512016: '三方验证设置失败',
    512017: '白名单观众不存在',
    512018: '白名单观众修改失败',
    512019: '白名单观众删除失败',
    512020: '白名单观众创建失败',
    512021: '邀请码创建数量超出限制',
    512022: '批量创建白名单观众超出限制',
    512023: '修改观看限制必要参数缺少',
    512024: '此白名单不属于该用户',
    512025: '观看限制保存失败',
    512026: '此活动类型不支持修改嘉宾',
    512027: '角色权限修改失败',
    512028: '创建专题失败',
    512029: '专题不存在',
    512030: '专题删除失败',
    512031: '专题修改失败',
    512032: '点播创建失败',
    512033: '回放不存在',
    512034: '点播不存在场次信息',
    512035: '点播不支持角色设置',
    512036: '此用户信息有部分已存在此分组中',
    512037: '白名单用户不存在',
    512038: '不能对其他账户下的白名单观众进行操作',
    512039: '用户组不存在',
    512040: '嘉宾口令和助理口令不能相同',
    512041: '专题不属于该用户',
    512042: '图片验证码错误',
    512043: '此音视频不属于该用户',
    512044: '音视频创建失败',
    512045: '音视频修改失败',
    512046: '音视频删除失败',
    512047: '活动扩展信息修改失败',
    512048: '回放不属于该用户',
    512049: '该分组已存在',
    512050: '用户并发量不足创建此活动',
    512051: '活动最高并发超出限制',
    512052: '正在直播中，请结束后操作!',
    512053: '您选择的模板不正确',
    512054: '此子账号不属于当前用户',
    512055: '活动直播中，不能删除',
    512056: '套餐不支持此功能',
    512057: '此图片资源无效',
    512058: '回放创建点播没有此权限',
    512059: '开始时间不能低于当前时间',
    512060: '该灰度环境标识已存在',
    512061: '活动迁移失败',
    512062: '刷新网关共享缓存失败',
    512063: '该专题已经下线!',
    512064: '插播不存在',
    512065: '插播不属于此用户',
    512066: '插播不属于此活动',
    512067: '插播创建失败',
    512068: '活动创建失败，超过账号最高连麦数',
    512069: '该活动已创建默认语种！',
    512070: '云导播不能是无延迟直播',
    512071: '该活动并不属于云导播活动！',
    512072: '云导播活动只能是视频直播！',
    512073: '标签名称已经存在',
    512074: '账号下最多创建1000条标签',
    512075: '最多只能关联50个标签',
    512076: '当前勾选标签不存在，请重新选择',
    512077: '标签已经置顶，不能重复置顶',
    512078: '标签删除失败',
    512079: '列表中有被引用标签，请重新选择',
    512080: '标签名称不能为空',
    512081: '活动id、专题id不能同时为空',
    512082: '多K值验证最多创建10个！',
    512083: '音视频不存在或已删除',
    512084: '请检测k_id是否正确',
    512085: '请检测活动ID与k_id是否对应',
    512086: '活动未开播',
    512087: '批量导出最多10个组',
    512088: '此视频资源不属于回放',
    512089: '此视频资源不支持转此清晰度',
    512090: '没有此清晰度权限',
    512091: '此视频尚未转码成功',
    512092: '直播中不可以修改视频和清晰度配置',
    512095: '定时直播所选音视频时长不得低于3分钟',
    512098: '老系统迁移活动不支持多个白名单',
    512101: '资源正在加密，无法操作',
    512102: '资源已经加密，无法操作',
    512103: '当前不具备定时直播权限',
    512104: '定时直播不支持恢复为预告',
    512105: '定时直播正在直播时，时间不支持修改',
    512106: '定时直播不支持主持人参会',
    512107: '直播中，定时直播不支持更换视频源',
    512108: '当前活动为定时直播，不支持修改活动状态',
    512109: '定时直播不支持嘉宾参会',
    512110: '用户没有分组活动权限',
    512111: '分组活动不可无观看限制',
    512112: '此专题无法设置统一限制，因为下属活动同时属于其他专题',
    512113: '回放属于彩排回放，不支持操作',
    512114: '活动正在彩排不支持本次操作',
    512115: '彩排中 ，不可调整',
    512116: '此回放不支持重制',
    512117: '彩排或直播中不允许修改配置项',
    512118: '彩排或直播中不允许进行开关操作',
    512119: '专题下最多仅支持设置200个活动',
    512120: '仅视频直播和定时直播支持创建竖屏模式',
    512121: '竖屏模式不支持云导播功能',
    512122: '暂无竖屏模式权限，请联系客服开通',
    512123: '竖屏模式仅app、sdk可以发起',
    512124: '竖屏模式不支持云导播',
    512125: '竖屏模式不支持视频轮巡',
    512126: '竖屏模式不支持直播间设计器',
    512127: '开播过的直播不允许修改横竖屏设置',
    512128: '实时字幕功能为收费功能，需要开通请联系您的商务经理或拨打客服电话',
    512129: '无延迟直播、分组直播和点播不支持实时字幕',
    512130: '非定时直播不支持此操作',
    512131: '此直播不支持此清晰度',
    512132: '当前视频正在转码其他清晰度，稍后转码完成后再提交新的清晰度转码',
    512200: '同一组中英文活动不能相同',
    512201: '一个活动不能同时添加到多个双语组内',
    512202: '专题下最大双语仅支持设置50个',
    512203: '此活动属于双语专题活动，不允许添加',
    512204: '双语专题活动不允许同时属于其他专题',
    512205: '活动组不存在或已删除',
    512206: '一个双语组中只能添加一个中文和一个英文活动',
    512300: '至少保留一个语种',
    512501: '活动创建者不存在',
    512502: '不支持的活动类型(flash)',
    512503: '不支持的活动类型(旧h5)',
    512504: '不支持的活动类型(点播)',
    512505: '没有找到房间',
    512506: 'Live_token已过期',
    512507: 'interact_token错误或已失效',
    512508: '非互动模式不支持嘉宾参会',
    512509: '未开启角色权限',
    512510: '当前口令错误，请联系主办方了解详情',
    512511: '当前已有主持人进入直播间',
    512512: '%s同时在线超过20人，无法进入直播间',
    512513: '检测到您已登录主办方账号，请先退出账号或使用其他浏览器访问',
    512514: '您已被禁止访问当前活动',
    512515: '未找到参会数据',
    512516: '该账号已进入直播',
    512517: '没有互动直播权限',
    512518: '互动模式不支持转播',
    512519: '不能重复转播',
    512520: '转播不能与转播源相同',
    512521: '直播未开始',
    512522: '主持人、嘉宾或助理直播时不能进入观看端',
    512523: '需要付费',
    512524: '被转播活动未开始直播',
    512525: '需要填写报名表单',
    512526: '检测类型和观看限制类型不一致',
    512527: '密码错误',
    512528: '请输入密码',
    512529: '邀请码错误',
    512530: '邀请码已被使用',
    512531: '请输入邀请码',
    512532: '请输入白名单手机号|邮箱|工号|其它',
    512534: '跳转链接',
    512535: '组织者对该活动设置了验证机制',
    512536: '回放不存在',
    512537: '热度不能小于在线人数',
    512538: '组织者对该活动设置了验证机制,验证失败',
    512539: 'Sdk验证只支持key值验证',
    512540: '活动已结束',
    512541: '活动现场太火爆，已超过人数上限',
    512542: '访客数据信息不全',
    512543: '此视频暂时下线了',
    512544: '该视频已下线，有疑问请联系客服',
    512545: '该视频转码失败',
    512546: '该视频正在转码中',
    512547: '亲，嵌入页面只支持三种验证方式：默认、密码、第三方k值！无法观看，请联系活动主办方',
    512548: '正在录制中，无法发起直播',
    512549: '非直播中活动',
    512550: '正在直播中，无法发起录制',
    512551: '仅支持音视频',
    512552: '分辨率错误，目前只支持 a,360p,480p,720p,same',
    512553: '回调地址格式错误',
    512554: '上传的点播不允许操作',
    512555: '当前分辨率已经转换，请勿重复操作!',
    512556: '当前分辨率正在转换，请勿重复操作!',
    512557: '当前分辨率系统转换失败!',
    512558: '当前分辨率的下载任务已请求，请误重复操作!',
    512559: '当前下载的分辨率回放未生成，请先生成后下载!',
    512560: '该视频正在审核中',
    512561: '流信息不存在',
    512562: '无极版流量已达上限',
    512563: '并发已达上限',
    512564: '无极版并发已达上限',
    512565: '活动所有者不是会员，暂不能进入',
    512566: '你有修改的章节正在保存中',
    512567: '不支持的活动类型(必须是点播)',
    512568: '未传入回调地址且回调地址未配置',
    512569: '无权操作主持人邮箱',
    512570: '短信验证码错误',
    512571: '流量用户欠费超过100G，暂不能进入',
    512572: '当前口令已失效，请联系主办方了解详情',
    512573: '邮箱已被他人使用',
    512574: '过期时间不能小于当前时间',
    512575: '过期时间不能超过30天',
    512576: '当前版本较低，请更新最新版本发起活动！',
    512577: '当前版本不支持发起无延迟直播，请升级到最新版本后使用',
    512578: '该活动已过期，无法发起直播',
    512579: '活动被管理员封禁',
    512580: '当前直播已被管理员强制结束，本次无法发起开播！',
    512581: '当前版本仅支持1v5连麦，使用更多连麦人数请升级至最新版本',
    512582: '当前版本不支持播放加密视频，请升级到最新版本后使用',
    512583: '暂不支持分组直播，请前往网页端发起',
    512584: '没有分组直播权限',
    512585: '暂不支持分组直播观看，请前往网页端',
    512586: '分组直播暂不支持虚拟人数设置',
    512587: '时长用户欠费超过100分钟，暂不能进入',
    512588: '分组直播暂不支持单视频嵌入观看',
    512591: '观看语种为收费功能，需要开通请联系您的商务经理或拨打客服电话',
    512592: '分组直播暂不支持多语言，请选择简体中文',
    512593: '当前版本不支持视频轮巡功能，请升级到最新版本后使用',
    512594: 'APP版本过低，请升级后使用',
    512595: '仅支持视频直播',
    512600: '开始或结束活动异常',
    512601: '开始或关闭转播流异常',
    512602: 'Symbol参数格式错误',
    512603: '身份信息格式错误',
    512604: '不是活动的回放',
    512605: '白名单失效，请清空缓存后重新填写',
    512606: '报名表单失效，请清空缓存后重新填写',
    512607: '请先执行开始打点',
    512608: '请求流媒体接口失败',
    512609: '主持人参会记录已存在',
    512610: '用户已使用白名单，请勿重复使用',
    512611: '用户已使用邀请码，请勿重新使用',
    512612: '活动ID已存在',
    512613: '记录不存在',
    512614: '时间跨度不得超过72小时',
    512615: '正在录制中，无法发起彩排',
    512616: '正在直播中，无法发起彩排',
    512617: '正在彩排中，无法发起直播',
    512618: '正在彩排中，无法发起录制',
    512619: '该直播正在彩排中,请升级到最新版，进入直播间',
    512620: '默认记录不能删除',
    512621: '不能操作非自己的kid',
    512622: '合并模式布局不支持第三方推流发起，请使用网页端发起',
    512623: '当前版本不支持合并模式布局，请升级到最新版本后使用',
    512624: '非无延迟视频直播合并模式布局不支持客户端及app，请使用网页端发起',
    512625: '验证方式只支持免费、密码和白名单',
    512626: '当前活动与账号信息不匹配，无法观看',
    512630: '分组直播和点播不支持直播实时AI纪要功能',
    512700: '活动下最多创建30路推流',
    512701: '推流地址已存在',
    512702: '推流记录不存在',
    512704: '正在进行第三方推流，请前往网页进入直播',
    512705: '推流仅支持音频、视频、互动、分组四种直播模式',
    512800: '报名表单不能与白名单同时开启',
    512801: '超过报名表单最大容纳题目数量限制',
    512802: '题目不存在',
    512803: '隐私协议不存在',
    512804: '超过单个题目容纳选项数量限制',
    512805: '没有操作权限',
    512806: '题目选项不存在',
    512807: '选项不能少于1个',
    512808: '当前角色禁止报名',
    512809: '短信验证码错误',
    512810: '报名数据缺失',
    512811: '题目选项必须为一个json串',
    512812: '题目禁止删除',
    512813: '已经添加过隐私协议',
    512814: '该手机已报名',
    512815: '用户已报名,无需重复报名',
    512816: '手机题目信息缺失',
    512817: '未报名',
    512818: '报名数据格式错误,答案录入失败',
    512819: '预报名excel内容错误',
    512820: '专题报名表单未开启',
    512821: '专题观看限制没有使用报名表单',
    512822: '快速报名最多限制200条数据',
    512823: '当前正在执行数据导入，请稍后',
    512824: '报名导入数据不存在',
    512825: '手机号不能重复报名',
    512826: '文件处理异常',
    512827: '专题报名表单选择指定活动报名时 webinar_ids 不能为空',
    512828: '检测到活动已被删除或未关联到专题下,请重试',
    512829: '登陆手机号和报名手机号不一致',
    512830: '已报名用户列表',
    512831: '报名手机号和登陆手机号不是同一用户',
    512855: '邮箱验证码错误',
    512856: '手机号与邮箱至少要保留一个，且为必填项',
    512900: '裁剪时间列表参数错误',
    512901: '转码中，请稍等',
    512902: '请重试',
    512903: '活动日志信息创建失败',
    512904: '活动日志信息修改失败',
    512905: '点播不能取消点默认',
    512906: '请先开始录制，再请求该',
    512907: '创建回放失败',
    512908: '时间范围已超出！',
    512909: '区间时间范围不能小于10秒！',
    512910: '最多选择20个视频文件',
    512911: '回放生成中，不能操作',
    512912: '视频已过观看有效期',
    512913: '观看端回放列表最多支持设置100个',
    512920: '当前回放内容没有演示文档',
    512921: '字段名称或者字段标识已存在',
    512922: '自定义字段不存在',
    512923: '自定义字段值长度不可超过100',
    512924: '直播自定义字段缺失',
    512925: '没有自定义字段权限',
    512926: '直播自定义字段最多支持5个',
    512931: '没有三方报名表单权限',
    512941: '自定义域名已存在',
    512942: '自定义域名生成失败',
    512997: '暂不支持付费活动发起直播，请调整后再开播',
    512998: '价格只允许输入0',
    512999: '合规自查中，该功能暂不支持使用',
    513000: '参会用户不存在',
    513001: '直播过程中禁止调用',
    513002: '直播未开始禁止调用',
    513003: '禁止操作',
    513004: '用户加入房间失败',
    513005: '删除失败',
    513006: '更新失败',
    513007: '房间不存在',
    513008: '主持人信息缺失',
    513009: '房间不是直播活动',
    513010: '房间已存在',
    513011: '当前参会用户未加入直播间',
    513012: '只有主持人拥有此权限',
    513013: '只有创建者拥有此权限',
    513014: '只有嘉宾允许操作',
    513015: '普通观众无此权限',
    513016: '问答必须处于开启状态',
    513017: '音频活动不能使用互动连麦',
    513018: '问答已被禁言',
    513019: '同问状态错误',
    513020: '用户无此权限',
    513021: '房间不存在',
    513022: '您参与的直播不是当前直播',
    513023: '暂未开放举手',
    513024: '角色不符',
    513025: '上麦席位已满员，您的账号支持%d人上麦',
    513026: '当前用户未申请上麦',
    513027: '当前用户没有参会',
    513028: '当前用户已经被邀请',
    513029: '重复上麦',
    513030: '没有被邀请',
    513031: '主持人不需要上麦',
    513032: '不允许下麦',
    513033: '用户未上麦',
    513034: '当前用户无法上麦',
    513035: '只有主持人可以对自己下麦',
    513036: '用户被禁言',
    513037: '当前参会用户不在演示中，无法操作',
    513038: '未开始讨论，发送公告失败',
    513039: '接口访问频繁，请稍后重试',
    513040: '超出严禁词数量限制',
    513041: '操作失败',
    513042: '关键词已被删除或不存在',
    513043: '关键词已存在',
    513044: '操作失败',
    513046: '跑马灯水印信息不存在',
    513047: '当前活动不属于当前用户',
    513048: '操作失败',
    513049: '开启水印时图片不能为空',
    513050: '菜单类型与状态不匹配',
    513051: '邀请榜功能组件只能添加一次',
    513052: '一个菜单下最多添加10个图文组件',
    513053: '一个页面内最多添加50个直播',
    513054: '一个页面内最多添加50个专题',
    513055: '不合法的组件数据',
    513056: '功能组件排行榜只能添加一次',
    513057: '自定义菜单数最多为6个',
    513058: '地址无效！',
    513059: '当前自定义菜单已经被删除',
    513060: '菜单不存在',
    513070: '创建失败',
    513071: '更新失败,推广信息不存在',
    513072: '删除失败,推广信息不存在',
    513073: '广告推荐个数已达到最大个数限制，请删除后再进行添加',
    513074: '广告推荐个数已达到最大个数限制，请删除后再进行添加',
    513075: '添加失败',
    513076: '上架失败',
    513077: '下架失败',
    513078: '复制失败',
    513079: '复制商品不存在',
    513080: '商品最大上架数量为:100',
    513081: '添加失败',
    513082: '更新失败',
    513083: '图片保存失败',
    513084: '删除失败,下架后才能删除',
    513085: '删除失败,图片不存在',
    513086: '设置失败,图片不存在',
    513087: '创建失败',
    513088: '更新失败',
    513089: '更新状态失败',
    513090: '创建失败',
    513091: '更新失败',
    513092: '操作失败',
    513093: '保存失败',
    513094: '未开启',
    513095: '创建邀请失败',
    513096: '创建邀请失败，活动id不匹配',
    513097: '文件地址错误',
    513098: '创建失败',
    513099: '红包金额必须大于零数字',
    513100: '活动不存在',
    513101: '资料库中已存在该文档',
    513102: '当前活动中已存在该文档',
    513103: '同步到资料库失败',
    513104: '同步到活动失败',
    513105: '当前要同步文档不存在',
    513106: '文档删除异常',
    513107: '当前活动中文档不存在',
    513108: 'Document参数不正确',
    513109: '文档已经删除或者不存在',
    513110: '当前文档归属不正确',
    513111: '请求文档不存在',
    513112: '当前用户无权限',
    513121: '问题不存在',
    513122: '请勿重复处理',
    513123: '答案不存在',
    513124: '房间开始时间缺失',
    513125: '问题不属于该房间',
    513126: '15s内不可提问',
    513127: '该消息已被删除',
    513128: '同一问题请勿频繁进行同问操作',
    513129: '未开启全员可见，不可操作',
    513200: '发起签到失败！',
    513201: '签到时长不能为空！',
    513202: '是否自动签到不能为空！',
    513203: '签到时间间隔不能为空！',
    513204: '当前活动已签到中！',
    513205: '签到已结束',
    513206: '签到不存在',
    513207: '推送时间必须大于当前时间以及直播开始时间！',
    513220: '点赞数据更新失败',
    513230: '分享类型错误',
    513231: '分享失败',
    513232: '分享失败',
    513240: '超过自定义礼物个数限制',
    513241: '当前用户无权限操作此房间',
    513242: '礼物信息不存在或者已删除！',
    513243: '系统礼物不能删除',
    513244: '只能删除自己创建的礼物',
    513245: '创建失败',
    513246: '编辑失败',
    513247: '礼物信息不存在',
    513248: '系统礼物不能编辑',
    513249: '你无权编辑此礼物信息',
    513250: '超过活动使用礼物数量限制',
    513251: 'Gift_ids格式错误',
    513252: '需要保持有一个礼物处于展示状态',
    513270: '文件信息参数错误',
    513271: '工单创建失败',
    513272: '工单创建失败,文件保存失败',
    513273: '工单信息不存在',
    513274: '工单回复失败',
    513275: '状态更新失败',
    513276: '工单问题已解决，禁止回复',
    513277: '请在控制台创建工单',
    513278: '没有权限',
    513280: '未获取到商品详情',
    513281: '折扣价不能大于等于原价',
    513282: '非法图片',
    513283: '商品不存在',
    513284: '封面必须存在图片中',
    513285: '商品已上架，如需编辑请先做下架处理',
    513288: '请直播开始后使用当前功能',
    513290: '推广申请不存在',
    513301: '文件格式错误',
    513302: '请使用模版文件上传',
    513311: '计时器已存在',
    513312: '计时器不存在',
    513321: '创建分组超出最大限制',
    513322: '分组申请资源失败',
    513323: '分组不存在',
    513324: '错误分组选择方式',
    513325: '当前用户未进入该房间',
    513326: '操作用户不在同一个房间',
    513327: '用户不是当前小组成员',
    513328: '用户不在线',
    513329: '只有普通用户才能被设为组长',
    513330: '未找到分组数据',
    513331: '您账号下有正在使用的子账号，请删除子账号后再注销当前账号',
    513332: '您还没有绑定手机号，为了保证您的权益，请登录网页端绑定手机号后再进行操作！',
    513333: '分组状态更新失败',
    513341: '已开启视频轮巡功能',
    513342: '您的连麦数已达到上限，暂无法开启视频轮巡功能，您可将观众下麦，再开启视频轮巡功能',
    513343: '视频轮巡未开启',
    513344: '无权限',
    513345: '您正在轮巡中，暂不能上麦',
    513346: '此观众正在轮巡中，暂不能上麦，请稍后再试',
    513350: 'number不能为空或者超出在线人数范围',
    513370: '文档水印类型格式错误',
    513371: '文档水印固定文本字数超过20',
    513390: '上传文档key不存在',
    513391: '文件检测失败或选择的模板不正确,请重试',
    513402: '当全体禁言开启聊天禁言不能设置关闭',
    513405: '删除机位失败',
    513407: '机位不存在',
    513410: '机位已存在',
    513420: '设置机位状态失败',
    513421: '需要填写手机号',
    513422: '需要填写带验证码的手机号',
    513423: '标识过期或不存在,请重试',
    513424: '未检测到无效文件',
    513425: '验证码不正确',
    513426: '参会用户数据异常',
    513500: '文件下载数据格式错误',
    513501: '未提交问卷',
    513502: '下载唯一标识不存在',
    513503: '数据不存在或已删除',
    513504: '生成下载地址异常',
    513505: '请选择问卷',
    513506: '最多添加50条数据',
    513507: '主办方更新了问卷，请重新填写',
    513508: '观看时长不足',
    513509: '请选择观看时长',
    513510: '观看时长超出范围',
    513532: '不能使用互动连麦相关功能',
    513533: '互动token缺失',
    513534: '活动类型不匹配,禁止操作',
    513535: '未获取到主持人信息',
    513536: '活动不匹配',
    513537: '当前用户无权限',
    513538: '未获取参会用户信息',
    513539: '导入文件时上传失败',
    513540: '没有数据可以导出',
    513541: '文件导出错误',
    513542: '参会角色权限等级低',
    513543: '请联系管理员开通权限',
    513544: '请上传素材',
    513545: '子账号只能获取自己账号下数据',
    513546: '获取key不能为空',
    513547: 'Open_id获取失败',
    513548: '打赏金额超出限制',
    513549: '上传文档超过最大限制',
    513550: '无效的图片路径',
    513551: '重复设置组长',
    513552: '隐私声明格式不正确',
    513553: '添加隐私协议超出预览字数，请删减后再添加',
    513554: 'statement_content 的值必须含有 statement_info 中 title 的值',
    513555: '白名单中没有预设分组，请选择其他分组方式',
    513556: '分组直播生效角色必须仅设置主持人',
    513560: '您尚未配置连麦数，请联系工作人员',
    513561: '请输入正确的小组号',
    513562: '分组标人数达到2000上限!',
    513563: '最大支持批量导出200条，请分批导出',
    513564: '账号下白名单数量超过限制',
    513570: '全局禁言已开启，不允许修改！',
    513600: '推屏卡片不存在',
    513601: '推送中禁止操作',
    513602: '最多创建200个推屏卡片',
    513603: '最多选择200个卡片',
    513611: '该观众已存在，不可重复添加',
    513621: '请先关联直播间',
    513622: '参与人数上限必须是100的整倍数',
    513623: '已发布，不能重复发布',
    513625: '已存在绑定关系，请先重置，再绑定',
    513626: '不存在绑定关系',
    513631: '开发者信息不存在，请先配置开发者信息',
    513632: '用户未授权',
    513633: '获取 token 失败',
    513641: '房间token已过期',
    513642: '房间token活动id不匹配',
    513643: '票务验证失败',
    513650: '红包开启条件不满足',
    514000: '邮箱一次最多1000',
    514001: '邮件地址无效',
    514002: '缺少查询id',
    514003: '缺少下载地址',
    514004: '当前上传类型，含有不被允许类型',
    514005: '当前上传类型不被允许',
    514006: '上传路径中含有特殊字符',
    514007: '上传文件不存在',
    514008: '上传文件不能超过4M',
    514009: '结束时间不能小于开始时间',
    514010: '时间格式不正确',
    514011: '邮箱发送失败',
    514012: '下载中心生成缺少必要参数',
    514013: '重新生成url请带上https!',
    514014: '授权失败，请刷新重试',
    514015: '上传文件失败，请重试',
    514021: '创建失败',
    514022: '修改失败',
    514023: '正在使用的版本不能下架',
    514061: '没有正在使用的版本',
    514062: 'System_type系统类型不能为空',
    514063: '非法访问！',
    514064: 'app英文名称已存在！',
    514065: 'bundle_id已存在！',
    514401: '请求频繁，稍后再试',
    515000: '机位已被占用',
    515001: '调用文档服务异常',
    515002: '票据已过期',
    515003: '票据已使用',
    515200: '活动不存在或不是h5活动',
    516000: '未知错误',
    516001: '非法访问',
    516002: '用户不存在',
    516003: '权限验证失败',
    516004: '系统忙，请稍后再试',
    516005: '签名校验失败',
    516006: '活动不存在',
    516007: '当前接口30秒内只能访问一次！',
    516016: '直播未开始',
    516017: '活动未在回放中',
    516026: '房间不是直播活动',
    516101: '当前套餐剩余有效时间不满一个月，不支持升级',
    516103: '删除订单失败!',
    516104: '无限包无法购买其他套餐',
    516105: '用户类型错误',
    516106: '升级并发必须大于当前并发',
    516107: '存在未生效并发包',
    516108: '您有待处理订单，暂不能新增',
    516109: '当前无可升级套餐，请联系客户经理购买',
    516110: '购买流量数量错误，请重新输入',
    516111: '套餐类型错误',
    516112: '您没有欠费',
    516113: '扩展包人数输入有误',
    516114: '欠费类型错误',
    516115: '订单不存在',
    516117: '处理支付回调失败，签名错误',
    516118: '订单状态异常',
    516119: '子账号不能操作',
    516120: '该账号为子账号，不能新增套餐/资源',
    516121: '请先清零欠费',
    516123: '请先清零回放流量欠费',
    516126: '此账号为父账号，无法新增无极包！',
    516127: '分配量不能超过可用量！',
    516128: '套餐结束时间不能早于当前时间！',
    516145: '并发人数范围为1至99999人',
    516149: '操作人id不存在',
    516150: '新增付费用户失败',
    516151: '订单类型错误',
    516200: '活动不存在或不是h5活动',
    516201: '统计活动基础数据异常',
    516202: '统计活动下省份维度异常',
    516203: '活动设备统计数据异常',
    516204: '活动浏览器统计数据异常',
    516205: '活动观看人数趋势图数据异常',
    516206: '活动观看并发趋势图数据异常',
    516207: '活动最大并发数异常',
    516208: '用户观看详情异常',
    516209: '查询活动热度异常',
    516210: '活动基本统计数据异常',
    516211: '获取当前在线人数异常',
    516212: '查询某个时间段内的在线人数异常',
    516213: '对外数据api用户观看详情异常',
    516214: '查询账号最大并发统计数据异常',
    516215: '账号时长统计数据异常',
    516216: '账号下活动最大并发详情统计数据异常',
    516217: '账号下活动消耗流量详情统计数据异常',
    516218: '活动个数超过限制',
    516219: '账户数据账户创建时间为空',
    516220: '查询时间范围错误',
    516223: '查询时间范围错误',
    516224: '查询时间错误',
    516300: '请先绑定手机号',
    516301: '验证码校验失败，请重试',
    516302: '并发预充值套餐无法购买扩展包',
    516303: '含有子账号的账号无法购买扩展包',
    516304: '订单已过期',
    516305: '短信验证码校验失败',
    516306: '请先绑定微信',
    516307: '提现金额不能小于1元',
    516308: '提现金额不能大于余额',
    516309: '流量用户欠费超过100g，暂不能进入',
    516310: '并发到期，暂不能进入',
    516311: '并发用户超过并发限制，暂不能进入',
    516312: '您有进行中的提现，无法再次提现',
    516313: '超过线上单笔最大提现额度，请走线下提现流程',
    516314: '请求下载中心失败',
    516315: 'Oss上传失败',
    516316: '导出文件生成失败',
    516317: '批量初始化子账号付费会员异常',
    516318: '超出可分配资源',
    516319: '子账号分配资源操作异常',
    516320: '存在不属于父账号的子账号',
    516321: '尊敬的会员，您的流量有欠费，请充值',
    516322: '尊敬的会员，您的流量已用尽，请充值',
    516323: '尊敬的会员，您有扩展包欠费，请充值',
    516324: '尊敬的会员，您的并发套餐已到期',
    516325: '订单生成失败',
    516326: '导出文件生成中',
    516327: '必填字段不能为空',
    516328: '查询订单支付详细信息失败',
    516329: '尊敬的会员，您的时长已用尽，请充值',
    516330: '尊敬的会员，您的时长有欠费，请充值',
    516331: '现场活动太火爆，已超过人数上限',
    516500: '初始化套餐资源包只支持[流量包并发包并发预充值包]',
    516501: '资源包类型异常',
    516502: '当前用户为非付费用户，请先新增付费用户',
    516503: '用户套餐不存在或已失效',
    516504: '暂无有效的套餐，请先添加套餐',
    516505: '无极版只能添加回放流量包',
    516506: '资源包不合法',
    516507: '已存在冲突资源包',
    516508: '保存资源包异常',
    516509: '父账号不支持此资源包',
    516510: '添加套餐资源绑定关系异常',
    516511: '资源包有效时间不能超出套餐有效时间',
    516512: '套餐时间内已有冲突套餐',
    516513: '资源包与计费类型冲突',
    516514: '请选择正确的并发预充值包计算峰值',
    516515: '资源以及金额不能为负',
    516516: '登录状态失效',
    516517: '功能版本不存在',
    516518: '资源包不存在',
    516519: '只有无极版用户能添加',
    516520: '付费用户已存在',
    516521: '注册用户初始化试用套餐失败',
    516522: '付费会员不存在',
    516523: '该用户不是子账号',
    516524: '来源不存在',
    516525: '非新版套餐，无法操作。请先转换旧版套餐',
    516526: '请联系客服升级套餐或返回旧版控制台进行购买',
    516527: '客户公司未填写，无法操作',
    516528: '无指定销售，无法操作',
    516529: '当前没有正在生效中的套餐资源',
    516530: '接收手机号和邮箱，2选1必填',
    516531: '最大不能超过当前资源',
    516532: '租户未绑定公众号',
    516604: '奖品创建/保存失败',
    516605: '当source为0时房间号/活动号必填',
    516606: '活动不存在或已删除',
    516607: '调用外部接口错误',
    516701: '上传的文件不存在或者错误',
    516702: '抽奖页还没有设置',
    516703: '抽奖已结束',
    516708: '您已参与过了',
    516709: '抽奖类型错误',
    516710: '抽奖进行中,无法再次发起抽奖',
    516711: '口令抽奖时口令不能为空',
    516712: '预设中奖用户校验未通过',
    516713: '您的角色不能发起抽奖',
    516714: '你的角色操作非法',
    516715: '设置的中奖人数不能大于可中奖人数',
    516716: '参数验证失败请检查',
    516719: '获取用户微信openid失败',
    516720: '此活动无需付费',
    516721: '您无此权限',
    516722: '抽奖不存在',
    516723: '未查询到中奖信息',
    516724: '抽奖/领奖页参数设置中不能包含emoji等特殊字符',
    516725: '奖品名称不能包含emoji等特殊字符',
    516726: '奖品数量不能大于20',
    516727: '活动id不能为空',
    516728: '调通用抽奖服务失败',
    516729: '奖品不存在',
    516730: '抽奖已删除',
    516731: '请先推送签到',
    516732: '请先推送指定问卷',
    516733: '请先推送指定快问快答',
    516734: '快问快答暂未完成分值计算',
    516735: '奖品不足',
    516736: '非进行中的抽奖不能结束',
    516737: '奖品数最多可设置2000个',
    516738: '开播后才能推送抽奖',
    516739: '抽奖已推送不能修改',
    516740: '设置奖品快照失败',
    516741: '抽奖进行中不能删除',
    516742: '抽奖已结束,无法再次发起抽奖',
    516743: '您没有签到权限',
    516744: '您没有问卷权限',
    516745: '您没有快问快答权限',
    516746: '您没有观众组权限',
    516747: '指定问卷已被删除，无法推送抽奖',
    516748: '指定快问快答已被删除，无法推送抽奖',
    516749: '请先推送问卷',
    516750: '已领取过该奖品',
    516751: '定时抽奖倒计时时间不能为0',
    516752: '抽奖结束中，请勿重复操作',
    516753: '互动有礼中奖记录不存在',
    516754: '优惠券奖品不允许复制',
    516755: '请求商品服务失败',
    516756: '请求回调服务失败',
    516757: '抽奖已推送，不能重复推送',
    516758: '抽奖未推送，不能结束',
    516759: '活动id不一致',
    516801: '获取PAAS票据失败',
    516802: '房间不匹配',
    516803: '无效的问卷',
    516804: '无此操作权限',
    516805: '已参与过，提交失败',
    516806: '表单拷贝失败',
    516807: '房间下问卷个数太多',
    516808: '用户未参会',
    516809: '用户已答问卷',
    516810: '回答参数异常',
    516811: '该用户不存在',
    516812: '房间id参数错误',
    516813: '鉴权异常',
    516814: '子账号信息不存在',
    516815: '该活动不是父账号下子账号的活动',
    516816: '未找到此问卷，请稍后重试',
    516817: '未找到此问卷对应的题目，请稍后重试',
    516818: '验证码已发送，请勿频繁请求',
    516819: '获取短信签名错误',
    516820: '提现金额不能小于2元',
    516821: '请上传申请单照片',
    516822: '上传的申请单照片格式错误',
    516823: '该用户正有一笔线下提现正在添加中',
    516824: '添加申请提现金额不能大于用户账户余额',
    516825: '用户账户余额小于0元',
    516826: '发送短信校验码失败',
    516827: '线下提现类型只能为直播和红包收益',
    516828: '有一笔订单正在处理中,请处理后再添加新的线下提现',
    516829: '提现,转账失败',
    516830: '该账户不是父账户',
    517218: '获取抽奖首页信息异常',
    517219: '获取房间下问卷列表错误异常',
    517220: '查询问卷各问题人数详情异常',
    517221: '资源参数数值异常(流量需为正数&并发需为正整数)',
    517222: '资源数请勿超出2位小数',
    518001: '互动有礼信息不存在！',
    518002: '问卷已被绑定，请检查',
    518003: '已涉及中奖，不允许操作',
    518004: '已涉及中奖，无法删除',
    518005: '礼品不存在',
    518006: '问卷已推送，无法删除',
    518007: '请选择问卷',
    518008: '批量创建礼品错误',
    518100: '观看有礼信息不存在！',
    518101: '您已参与过该观看有礼！',
    518102: '不满足观看时长条件！',
    518103: '无需领奖！',
    518104: '观看有礼不存在或未推送！',
    518105: '当前账号不在线，无法参与观看有礼！',
    518106: '非未推送状态不允许修改奖品信息！',
    518107: '观看有礼已推送，不允许操作',
    518108: '请添加领奖配置',
    518109: '抽奖策略获取失败',
    518111: '每个活动最多创建1000个',
    519001: 'AI聊天主题不存在',
    519002: '未添加马甲昵称！',
    519003: '未添加评论内容！',
    519004: '上传数量达到上限！',
    519005: '主题推送中，不允许编辑',
    519006: '主题推送中，不允许操作',
    519007: '聊天机器人信息不存在',
    519008: '聊天机器人含有特殊字符',
    519009: '聊天机器人不能为空',
    519010: '暂不支持该消息类型',
    519011: '常用语不存在',
    519012: '默认常用语不允许编辑',
    519013: '常用语数量超过限制',
    519014: '常用语已存在',
    520001: '商城奖励不存在',
    520002: '商城奖励不允许操作',
    520003: '商城奖励已推送，不允许操作',
    520004: '非手动推送，不允许操作',
    520005: '未设置奖励，请检查',
    520006: '其他奖励正在推送中',
    520007: '商城奖励未推送',
    520008: '您已领取过该奖励',
    520009: '可创建数量超过限制',
    520010: '当前观看时长已存在，请重新选择',
    520011: '可选奖励超过限制',
    520012: '观看时长不足，无法领取',
    520013: '批量编辑数量超过限制',
    520014: '开发平台创建奖品信息奖品标识不能为空',
    520015: '开发平台创建奖品信息奖品标识不能重复',
    520098: '商城奖励已结束',
    520099: '奖励已被抢光',
    521001: '调通用打赏服务失败',
    530002: '活动不存在',
    530006: '上传文件失败',
    530007: '创建商品失败',
    530008: '商品创建参数缺失',
    530021: '订单信息发生变化，请关闭此弹窗后重新进行下单',
    530022: '预下单失败',
    530023: '支付系统异常',
    530024: '订单不存在',
    530025: '订单回调验签失败',
    530026: '外链商品不支持下单',
    530027: '商品缺失APP购买模板链接',
    530028: 'js_api签名错误',
    530029: '不支持混合的购买类型',
    530030: '只能购买一种商品',
    530031: '未找到对应的支付链接',
    530032: '下单太频繁,请稍后再提交',
    530033: '商品不存在或已下架',
    530034: '调用支付系统超时',
    530035: '用户优惠劵不存在',
    530036: '用户优惠劵已使用或已失效',
    530037: '非指定商品，不可使用该优惠劵',
    530038: '此商品不可使用该优惠劵',
    530039: '下单商品不匹配',
    530040: '商品暂未开价,不允许购买',
    530041: '订单号已存在',
    530071: '商户号暂未绑定，请先绑定商户号',
    530072: '商品操作失败',
    530073: '商品重复添加',
    530091: '活动商品创建超出限制',
    530092: '商品ID不能为空或者null',
    530093: '活动商品操作失败',
    530094: '活动商品不存在或者未上架',
    531000: '查询用户个数不能超过现在',
    531001: '数据订阅规则不存在',
    531002: '数据订阅规则配置个数超过限制',
    531003: '时长数据订阅规则:规则条件错误',
    531004: '时长数据订阅规则:起始时长过短',
    531005: '时长数据订阅规则:时长规则时间最小间隔过短',
    531006: '时长数据订阅规则:数据订阅周期太长',
    532001: '不支持的支付方式',
    532002: '订单单金额不允许修改',
    532004: '订单不存在或者订单号和appId不匹配',
    532005: '第三方下单失败，请联系开发人员',
    532006: '订单已经支付，无法再次申请支付',
    532007: '未配置对应支付方式参数，请联系开发人员配置支付参数',
    532008: '微信下单失败',
    532009: '获取微信支付参数时返回的参数错误',
    532010: '关闭订单失败',
    532011: '查询订单失败',
    532012: '支付方式不能改变',
    532013: '初始化证书文件失败',
    532014: '订单已存在，不允许重复下单',
    532015: '服务商配置对应商户不正确',
    532016: '商户类型不匹配',
    532017: '商户转账场景不匹配',
    532018: '转账单已存在',
    532019: '转账单不存在',
    532020: '转账单状态不正确',
    530018: '设置活动商品状态异常',
    530010: '未查询到预售商品',
    530011: '未查询到自动弹出商品',
    540000: '优惠券不存在',
    540001: '活动下优惠券不存在',
    540002: '优惠券已被删除！',
    540003: '商品已失效！',
    540004: '活动下优惠券数量不能超过200！',
    540005: '优惠券所属用户uid错误',
    540006: '优惠券已失效,请重新选择！',
    600000: '该父账户有开通子账号权限或者已经存在子账号，不能开通时长套餐',
    600001: '无极版本不支持开通时长套餐',
    600002: '超过添加的最大资源',
    600003: '仅化蝶用户且无flash活动的迁移账户支持设置时长套餐',
    600004: '用户有flash活动未处理',
    600005: '资源包不能作废',
    600006: '尊敬的会员，您的套餐已用尽，请充值',
    600007: '请输入小于当前余额的正整数',
    600010: '精彩片段不存在',
    600011: '精彩片段创建失败',
    600012: '精彩片段创建中',
    600020: '概要总结不存在',
    600021: '概要总结不能编辑',
    600030: '精彩时刻不存在',
    600031: '精彩时刻不能编辑',
    600040: '智能字幕不存在',
    610001: '文件不存在',
    614000: '用户无此数据的权限',
    614001: 'client参数无效',
    614002: '参数验证失败，请检查',
    614003: '数据处理失败',
    614004: '不是分组直播，无法发送小组公告',
    614200: '有文档活动直播中不能删除文档!',
    614201: '文档不存在!',
    614202: '文档已经同步!',
    614203: 'webinar_id与文档id不匹配!',
    614204: '文档上传oss地址参数错误!',
    614205: '消息已删除或不存在!',
    615000: '角色不合法',
    618000: '服务请求失败',
    618100: '发送聊天参数错误',
    620001: '智能解析不存在',
    620002: '智能解析未完成',
    620004: '当前视频时长低于3分钟，请选择其他视频进行解析',
    620005: '正在创作中，请耐心等待',
    620006: '创作失败，请重新创作',
    620007: '校正已完成，不能编辑',
    620010: '精彩片段不存在',
    620011: '精彩片段创建失败',
    620012: '精彩片段生成中',
    620020: '概要总结不存在',
    620021: '概要总结不能编辑',
    620030: '精彩时刻不存在',
    620031: '精彩时刻不能编辑',
    620040: '智能字幕不存在',
    650000: '上传图片大小不能超过10M',
    650001: '红包已推送，不允许操作',
    650002: '红包个数必须大于0',
    650003: '现金红包信息不存在！',
    650004: '现金红包已推送，不能重复推送',
    650005: '现金红包信息错误，请重新配置',
    650006: '现金红包还未推送，不能结束',
    650007: '现金红包已结束',
    650008: '现金红包已被抢光了',
    650009: '现金红包金额不够分',
    650010: '现金红包限制不满足',
    650011: '现金红包太小了',
    650012: '仅允许无限制红包主动推送',
    650013: '回放仅支持定时红包',
    650014: '所有红包均已推送，不允许操作',
    650016: '现金红包已经被删除，无法在领取',
    650017: '现金红包领取时间已过期',
    650018: '红包活动未参会',
    650019: '当前房间状态非回放',
    650020: '领取失败，无法再次领取',
    650021: '同一时间只能发送一个红包',
    650022: '您已领取过本次红包',
    650023: '现金红包已经被删除',
    650024: '红包开启条件不满足',
    650025: '直播中不能启用开关',
    801304: '绑定渠道失败，不允许操作',
    5100016: '请勿频繁操作',
    5100017: '创建失败',
    5100018: '更新失败',
    5100019: '数据不存在',
    5100230: '直播中不允许此操作',
    5100231: '请勿在短时间内重复请求！',
    5100232: '主办方开启了「微信强制登录」，请联系主办方',
    5100233: '没有此功能权限，请联系客服开通',
    5100236: '无管理端操作权限！！！',
    5120026: '数据数量超出限制',
    5136001: '当前没有可用视频',
    5513334: '分组创建失败',
    5513335: '移动端用户暂不支持提升组长',
    5513336: '分组未初始化不能调用该接口',
    5513337: '分组直播不支持此配置',
    8010000: 'CorpId不能为空',
    8010001: 'CorpId不存在',
    8010002: 'CorpUserId不能为空',
    8010003: '授权信息不存在',
    8010004: '仅支持C端用户',
    8010005: '企业信息不存在',
    8010006: '企业信息异常',
    8010007: '签名验证失败',
    8010008: '生成签名url不能为空',
    8010009: '企微接口-获取应用token失败',
    8010010: '企微接口-获取供应商token失败',
    8010011: '企微接口-获取企业token失败',
    8010012: '企微接口-获取企业预授权码失败',
    8010013: '企微接口-调用企业内部应用获取访问用户身份失败',
    8010014: '企微接口-获取永久授权码和企业信息失败',
    8010015: '企微接口-获取部门列表失败',
    8010016: '企微接口-获取部门成员详情失败',
    8010017: '企微接口-批量获取客户详情失败',
    8010018: '企微接口-获取客户详情失败',
    8010019: '企微接口-获取访问用户身份失败',
    8010020: '企微接口-获取用户敏感信息失败',
    8010021: '微信获取应用jsapi_ticket失败',
    8010022: '企微接口-获取企业jsapi_ticket失败',
    8010023: '企微接口-企业主体unionId换外部联系人id失败',
    8010024: '企微接口-第三方主体unionId换外部联系人id失败',
    8010025: '企微接口-互通账号失效需购买激活码进行激活',
    8010026: '企微接口-读取成员信息失败',
    8010027: '企微接口-创建联系我失败',
    8010028: '企微接口-删除联系我失败',
    8010029: '获取访问用户身份-不是企业成员且不是企业客户',
    8010030: '企业成员信息不存在',
    8010050: '公众号接口-获取ticket失败',
    8010100: '平台授权登录创建C端用户-注册SSO失败',
    8010101: 'sso-token验证失败',
    8010102: '手机号未注册',
    8010103: '手机号已注册',
    8010104: '邮箱未注册',
    8010105: '邮箱已注册',
    8010106: '账号已注册',
    8010107: 'token已失效',
    8010108: 'token已登出',
    8010109: '错误的用户类型',
    8010110: '账号不存在',
    8010111: '密码错误',
    8010112: '发送验证码失败',
    8010113: '验证码无效',
    8010114: '业务线未配置微吼云资源',
    8010115: '业务线未配置短信模板',
    8010116: '验证码已发送',
    8010117: '用户已被禁用',
    8010118: '邮件模板配置不存在',
    8010120: '网络头像不合法',
    8010121: '上传图片过大',
    8010122: '上传文件类型不支持',
    8010123: '当前第三方用户已创建,密码数据不一致,请使用更新接口修改数据',
    8010124: '请勿短时间内重复请求',
    8010125: '该手机号已存在',
    8010126: '该邮箱已存在',
    8010127: '授权检查失败',
    8012000: '用户信息参数缺失',
    8012001: '查询条件为空',
    8012002: '保存失败',
    8012003: '根据邀请码未查询到邀请发送记录',
    8012004: '自定义模板最大数量为5',
    8012005: '系统错误，请稍后重试',
    8012006: '请选择1个邀请卡处于显示状态',
    8012007: '活动信息错误',
    8012008: 'B端用户ID不能为空',
    8013001: '渠道名称和渠道编码均重复',
    8013002: '参数[channel_ids]不能为空',
    8013003: '删除渠道失败，不允许操作',
    8013005: '包含未绑定的渠道，不允许操作',
    8013006: '包含已绑定的渠道，不允许操作',
    8013007: '最多可以创建200个渠道',
    8013009: '渠道名称重复',
    8013010: '渠道编码重复',
    8013011: 'scene_type不能为空',
    8014000: '未找到对应的引流配置',
    8014011: '没有找到托管公众号信息',
    8014012: '托管公众号状态无效',
    8014013: '远端调用失败',
    8014014: '授权超时',
    8014015: 'lack refresh token',
    8014016: '默认公众号授权状态异常',
    8014017: '获取授权失败',
    8014020: 'component_appid未找到',
    8014021: '生成预授权码失败',
    8014022: '无效授权状态',
    8014023: '无效usage',
    8014024: 'refresh authorizer token failure',
    8014030: '创建带参二维码失败',
    8014100: '不是实体Owner，无权限操作',
    8014101: '不是有效的URL',
    8014102: 'page_path不能以/开头和结尾',
    8014103: '生成小程序码失败',
    8014104: '小程序登录失败',
    8015001: '查询条件为空',
    8015002: '标签名称已存在',
    8015003: '未查询到数据',
    8015004: '标签已经置顶，不能重复置顶',
    8015005: '标签未置顶，不能取消置顶',
    8015006: '标签已标注，不能重复标注',
    8015007: '标签不存在',
    8015008: '平台级标签不许修改',
    8015009: '只能修改自己创建的标签',
    8015010: '分类名称已存在',
    8015011: '排序上移时，下方记录ID不能为空',
    8015012: '排序下移时，上方记录ID不能为空',
    8015013: '不允许批量修改名称',
    8015014: '标签不支持跨租户更新',
    8015015: '标签分类不存在',
    8015016: '批量查询单次不能超过100条',
    8015017: 'B租户不存在',
    8015018: 'sourceType转换异常',
    8019000: '表单信息不存在',
    8019001: '表单已被删除',
    8019002: '未查询到表单题目信息',
    8019003: '微吼云表单信息不存在',
    8019020: '表单绑定关系不存在',
    8019040: '表单回答信息无效',
    8019041: '表单答案已存在',
    8020000: '通知配置信息不存在',
    8020002: '通知配置信息不匹配',
    8020003: '发送时间类型不匹配',
    8020004: '通知模板不存在',
    8020005: '通知已发送不允许再修改模板',
    8020006: '已发送的时间不能被删除',
    8020007: '自定义发送时间不能重复',
    8020008: '相对的发送时间不能重复',
    8020009: '通知类型不合法',
    8020010: '默认模板不能删除',
    8020011: '短信签名不能重复',
    8020012: '短信签名更新异常',
    8020013: '系统错误，请稍后重试',
    8020014: '活动信息不存在',
    8020015: '预约/报名不支持修改时间',
    8020016: '该模版不支持设置相对时间',
    8020017: '微信模版添加失败',
    8020018: '未设置微信通知模版',
    8020019: '短信签名不存在',
    8020020: '短信签名已使用，请勿重复操作',
    8020021: '默认短信签名不允许删除'
  },
  el: {
    colorpicker: {
      confirm: '确定',
      clear: '清空'
    },
    datepicker: {
      now: '此刻',
      today: '今天',
      cancel: '取消',
      clear: '清空',
      confirm: '确定',
      selectDate: '选择日期',
      selectTime: '选择时间',
      startDate: '开始日期',
      startTime: '开始时间',
      endDate: '结束日期',
      endTime: '结束时间',
      prevYear: '前一年',
      nextYear: '后一年',
      prevMonth: '上个月',
      nextMonth: '下个月',
      year: '年',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      week: '周次',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      months: {
        jan: '一月',
        feb: '二月',
        mar: '三月',
        apr: '四月',
        may: '五月',
        jun: '六月',
        jul: '七月',
        aug: '八月',
        sep: '九月',
        oct: '十月',
        nov: '十一月',
        dec: '十二月'
      }
    },
    select: {
      loading: '加载中',
      noMatch: '无匹配数据',
      noData: '无数据',
      placeholder: '请选择'
    },
    cascader: {
      noMatch: '无匹配数据',
      loading: '加载中',
      placeholder: '请选择',
      noData: '暂无数据'
    },
    pagination: {
      goto: '前往',
      pagesize: '条/页',
      total: '共 {total} 条',
      pageClassifier: '页'
    },
    messagebox: {
      title: '提示',
      confirm: '确定',
      cancel: '取消',
      error: '输入的数据不合法!'
    },
    upload: {
      deleteTip: '按 delete 键可删除',
      delete: '删除',
      preview: '查看图片',
      continue: '继续上传'
    },
    table: {
      emptyText: '暂无数据',
      confirmFilter: '筛选',
      resetFilter: '重置',
      clearFilter: '全部',
      sumText: '合计'
    },
    tree: {
      emptyText: '暂无数据'
    },
    transfer: {
      noMatch: '无匹配数据',
      noData: '无数据',
      titles: ['列表 1', '列表 2'],
      filterPlaceholder: '请输入搜索内容',
      noCheckedFormat: '共 {total} 项',
      hasCheckedFormat: '已选 {checked}/{total} 项'
    },
    image: {
      error: '加载失败'
    },
    pageHeader: {
      title: '返回'
    },
    popconfirm: {
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    },
    empty: {
      description: '暂无数据'
    }
  }
};
